<template>
    <div id="calendar-track" class="calendar-track">
        <h2 v-if="track">{{track.name}}</h2>
        <h2 v-else-if="$route.params.trackId == 0">Sessions</h2>
        <h2 v-else-if="isMyTrack">Attending</h2>

        <div v-if="track && track.description" v-html="track.description"
            class="calendar-track-description"></div>

        <CalendarListing 
            :itemsByDate="trackByDate"
            :timezone="timezone"
            :me="me"
            @modal="doModal"
        />
        <!--
        <div v-for="(day, index) in trackByDate" :key="index"
            class="calendar-track-day"
        >
            <div class="calendar-track-date">
                {{asDateOnly(day[0].end_time_utc, timezone)}}
            </div>

            <div class="calendar-track-day-list">
                <CalendarItem v-for="(item, iIndex) in day" 
                    :key="index+'-'+iIndex" 
                    :item="item"
                    :timezone="timezone"
                    @click="doModal(item)"
                >
                    <CalendarIcon :item="item" :me="me" />
                    <div class="calendar-item-meta">
                        <CalendarItemTime :item="item" :timezone="timezone" />
                        <CalendarItemLocation :item="item" />
                    </div>
                    <div class="calendar-track-detail">
                        <CalendarItemDetails :item="item" />
                    </div>
                </CalendarItem>
            </div>
        </div>
        < !-- filtered -- >
        <div v-if="Object.keys(trackByDate).length == 0"
            class="calendar-track-empty"
        >
            <span>TRACK EMPTY</span>
        </div>
        -->
    </div>
</template>

<script>
/** Iterate through the list inserting LOCAL day boundaries as required.
 */
import CalendarListing from "@/views/calendar/CalendarListing";

// import CalendarIcon from "@/views/calendar/CalendarIcon";
// import CalendarItem from "@/views/calendar/CalendarItem";
// import CalendarItemDetails from "@/views/calendar/CalendarItemDetails";
// import CalendarItemLocation from "@/views/calendar/CalendarItemLocation";
// import CalendarItemTime from "@/views/calendar/CalendarItemTime";

import {asDateOnly} from '@/utils/DateTime';
import {trackKeyFromId} from "@/utils/Filter";
import {compareStartTimeUTC, groupByDate} from '@/utils/Sort';


export default {
    name: "CalendarTrack",
    props: {
        items: {
            type: Array,
            required: true,
        },
        itemsByDate: {
            type: Object,
            required: true,
        },
        privatesByDate: {
            type: Object,
            required: true,
        },
        busySlotIds: {
            type: Set,
            required: true,
        },
        itineraryByDate: {
            type: Object,
            required: true,
        },
        pageDate: {
            type: String,
            required: true,
        },
        eventDates: {
            type: Array,
            required: true,
        },
        activeDates: {
            type: Array,
            required: true,
        },
        itineraryDates: {
            type: Array,
            required: true,
        },
        event: {
            type: Object,
            required: true,
        },
        timezone: {
            type: String,
            required: true,
        },
        filters: {
            type: Object,
            required: true,
        },
        toggles: {
            type: Object,
            required: true,
        },
        slots: {
            type: Array,
            required: false,
        },
        tracks: {
            type: Array,
            required: false,
        },
        me: {
            type: Object,
            required: false,
        }
    },
    components: {
        CalendarListing,
        // CalendarIcon,
        // CalendarItem,
        // CalendarItemDetails,
        // CalendarItemLocation,
        // CalendarItemTime,
    },
    computed: {
        trackKey() {
            return trackKeyFromId(this.$route.params.trackId);
            // return 'track'+this.$route.params.trackId;
        },
        track() {
            // Remember: track won't exist for my/track0
            return this.tracks.find(track => track.id == this.$route.params.trackId);
        },
        isMyTrack() {
            return this.$route.params.trackId == 'my';
        },
        tracksOrdered() {
             // 'my' isn't a real track
            if (this.isMyTrack) {
                return [ ...this.filters.ticketed].sort(compareStartTimeUTC);
            }
            if (this.trackKey) {
                if (this.filters[this.trackKey]) { 
                    return [ ...this.filters[this.trackKey] ].sort(compareStartTimeUTC);
                }
            }
            return [];
        },
        trackByDate() {
            if (! this.tracksOrdered) { return {}; }

            return groupByDate(
                this.tracksOrdered,
                'start_time_utc', 
                this.timezone
            );
        },
    },
    methods: {
        asDateOnly,
        doModal(item) {
            this.$emit('modal', {
                item: item,
                items: this.tracksOrdered
            });
        },
    }
}
</script>

<style>
.calendar-track-day {
    border-top: none;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    padding-top:5px;
}

.calendar-track-day .calendar-track-date {
    position: static;
    font-weight: bold;
    padding: 5px 20px 5px 5px;
    min-width: 60px;
    border-bottom: 2px solid #ccc;
}
.calendar-track-day-list {
    flex-grow: 1;
}

/* CalendarItem customisation! */
#calendar-track .calendar-item {
    padding: 5px;
    flex: 1 1 auto;
    gap: 10px;
    border-bottom: 1px solid #ccc;
}
#calendar-track .calendar-item:last-child {
    border-bottom: none;
}

#calendar-track .calendar-icon {
    width: 16px;
}
#calendar-track .calendar-item-meta {
    width: 200px;
    max-width: 200px;
    min-width: 200px;
}
#calendar-track .calendar-item-title {
    font-weight: bold;
}

#calendar-track .calendar-item-organisation-name {
    font-style: italic;
}

#calendar-track .calendar-track-status {
    margin: 0 10px 0 0;
}

.calendar-track-empty {
    background-color: #ccc;
    display: grid;
    align-content: center;
    justify-content: center;
    margin-top: 30px;
    padding: 10px;
}
.calendar-track-empty span {
    color: #fff;
    font-weight: bold;
}
</style>